export class BenefitClaimResponse {

    claimStatus?: string ;
    claimNumber?: string ;
    oldClaimNumber?: string ;
    clientNumber?: string ;
    userName?: string ;
    problem?: string ;
    decision?: string ;
    comment?: string ;
    centralizationAddressPSM?: string ;
    proximityAddressPSM?: string ;


}